import { Badge } from '@/components/ui/badge'
import { BAND_CLASSES, BAND_DOT, BAND_NAMES, CHURN_CLASSES, churnTitle } from '@/lib/kpiBands'
import type { Churn, KpiBand } from '@/types/clientKpis'
import { cn } from '@/lib/utils'

const NotEnoughData = ({ title }: { title?: string }) => (
  <Badge variant="neutral" title={title} className="font-medium">
    Not enough data
  </Badge>
)

export function PercentPill({ percent, band, title }: { percent: number | null; band: KpiBand | null; title?: string }) {
  if (percent == null || !band) return <NotEnoughData title={title} />
  return (
    <Badge variant="outline" title={title} className={cn('border-transparent tabular-nums', BAND_CLASSES[band])}>
      {percent}%
    </Badge>
  )
}

export function BandDot({ band, className }: { band: KpiBand | null; className?: string }) {
  return (
    <span
      aria-label={band ? BAND_NAMES[band] : 'No band'}
      title={band ? BAND_NAMES[band] : undefined}
      className={cn('inline-block size-[9px] shrink-0 rounded-full', band ? BAND_DOT[band] : 'bg-etn-border-hairline', className)}
    />
  )
}

export function ChurnPill({
  churn,
  className,
}: {
  churn: Pick<Churn, 'level' | 'raisedFrom' | 'fell' | 'noRenewalDate' | 'fallingMonths'> | null
  className?: string
}) {
  if (!churn?.level) return <NotEnoughData />
  return (
    <Badge variant="outline" title={churnTitle(churn)} className={cn('cursor-help border-transparent', CHURN_CLASSES[churn.level], className)}>
      {churn.level}
    </Badge>
  )
}
